/* eslint-disable max-len */
import Dispatchers from '@/mixins/dispatchers';
const BastanteoItem = () =>
    import(/* webpackChunkName: "BastanteoItem" */ '@/views/shared/bastanteo/bastanteo-item');

export default {
    name: 'BastanteoAssociatesPatrons',

    mixins: [Dispatchers],

    components: {
        BastanteoItem
    },

    /**
     * @override
     */
    data() {
        return {
            opened: false,
            docsPending: 0,
            type: 'account'
        };
    },
    props: {
        itemActive: {
            type: Object,
            required: false
        },
        items: {
            items: Array,
            required: true
        },
        account: {
            type: Object,
            required: true
        }
    },
    computed: {
        documentTitleFragment() {
            return (index) => {
                if (this.items && this.items.length) {
                    const title = this.items[index].title; 
                    const match = title.match(/_(\d{8}[A-Z])/);
                    return match ? match[1] : '';
                }
                return '';
            }
        }
    },

    methods: {
        /**
         * Muestra documento en ventana flotante
         * @param {Object} item documento a mostrar
         */
        showDocumentInWindow(item) {
            const typeData = {
                type: 'account',
                uuid: item.uuid,
                is_validated: item.is_validated
            };
            item = item.data;
            item.type = typeData;
            this.$store.dispatch('bastanteoStore/setNewFloatWindow', item);
        }
    },
    /**
     * @override
     */
    watch: {
        items: {
            handler() {
                const docsPendingRequired = this.items.filter(x => !x.is_validated || x.is_validated === null);
                this.docsPending = docsPendingRequired.length;
                this.$root.$emit('emit_items_not_validated', docsPendingRequired);
            },
            immediate: true
        }
    }
};
